import { useCallback, useState } from 'react';

// Tracks which fields AI filled so the marker disappears as soon as the user edits one.
export function useAiFilledFields<TField extends string>() {
  const [aiFilled, setAiFilled] = useState<Set<TField>>(new Set());

  const markAiFilled = useCallback((fields: TField[]) => {
    setAiFilled((prev) => {
      const next = new Set(prev);
      fields.forEach((f) => next.add(f));
      return next;
    });
  }, []);

  const clearAiFilled = useCallback((field: TField) => {
    setAiFilled((prev) => {
      // Without this guard every keystroke after the first would set state and re-render.
      if (!prev.has(field)) return prev;
      const next = new Set(prev);
      next.delete(field);
      return next;
    });
  }, []);

  const resetAiFilled = useCallback(() => setAiFilled(new Set<TField>()), []);

  const isAiFilled = useCallback((field: TField) => aiFilled.has(field), [aiFilled]);

  return { isAiFilled, markAiFilled, clearAiFilled, resetAiFilled };
}
